import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import Activities, { IActivitiesDispatchProps, IActivitiesProps } from './Activities'
import {
  getUserActivitiesList,
  getUserActivitiesLoading,
  getUserActivitiesHasLoaded,
  getActivitiesLoadingMore,
  getActivitiesHasMore,
  getActivitiesOffset,
  getReviewModalOpen,
  getDuplicates,
  getDuplicatesMainId,
  getDuplicatesLoading,
  getSettingMain,
} from './store/ActivitiesSelectors'
import {
  getUserActivities,
  loadMoreActivities,
  deleteActivity,
  openReviewDuplicates,
  closeReviewDuplicates,
  setMainActivity,
} from './store/ActivitiesActions'
import { getUserCompanies, getUserDto } from '../../common/auth/authSelectors'

const mapStateToProps = (state: IGlobalState): IActivitiesProps => ({
  userActivities: getUserActivitiesList(state),
  isLoading: getUserActivitiesLoading(state),
  hasLoaded: getUserActivitiesHasLoaded(state),
  isLoadingMore: getActivitiesLoadingMore(state),
  hasMore: getActivitiesHasMore(state),
  offset: getActivitiesOffset(state),
  userDto: getUserDto(state),
  userCompanies: getUserCompanies(state),
  reviewModalOpen: getReviewModalOpen(state),
  duplicates: getDuplicates(state),
  duplicatesMainId: getDuplicatesMainId(state),
  duplicatesLoading: getDuplicatesLoading(state),
  settingMain: getSettingMain(state),
})

const mapDispatchToProps: IActivitiesDispatchProps = {
  getUserActivities,
  loadMoreActivities,
  deleteActivity,
  openReviewDuplicates,
  closeReviewDuplicates,
  setMainActivity,
}

export default connect(mapStateToProps, mapDispatchToProps)(Activities)
